module.exports = __webpack_public_path__ + "img/carshina22_14.4ce7c2cc.jpg";